import {Component, ElementRef, HostListener, OnInit, OnDestroy, Renderer2, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {UploadService} from '../upload.service';
import {DocListComponent} from '../doclist/doclist.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {CreateGoogleDriveComponent} from '../google-drive/create-google-drive.component';
import {CreateOneDriveComponent} from '../onedrive/create-onedrive.component';
import {TranslateService} from '@ngx-translate/core';
import {CreateFolderComponent} from '../create-folder/create-folder.component';
import {UploadFilesComponent} from '../upload-files/upload-files.component';
import {Path} from 'app/shared/path';
import {Subscription} from 'rxjs';
import {Toast} from 'app/shared/toast/toast';
import {AppComponent} from 'app/app.component';
import {DownloadZipComponent} from '../download-zip/download-zip.component';
import {MoveDialogComponent} from '../move/move.component';
import {ConfirmDeleteComponent} from '../confirm-delete/confirm-delete.component';
import {FileSizePipe} from '../../shared/file-size.pipe';
import {FileUploader} from '../file-uploader';
import {UploadProgressComponent} from '../upload-progress/upload-progress.component';
import { GoogleAnalyticsService } from 'app/google-analytics.service';

declare let EnjoyHint: any;

@Component({
   selector: 'app-files',
   templateUrl: './files.component.html',
   styleUrls: ['./files.component.css']
})
export class FilesComponent implements OnInit, OnDestroy {
   @ViewChild(DocListComponent, {static: true}) docList: DocListComponent;
   @ViewChild('fileUpload') fileUpload: any;
   @ViewChild('progress') progress: UploadProgressComponent;
   private path: string;
   public canDrag = true;
   paths: any[];
   doc: any;
   selectedItems: any[] = [];
   permisionMove = true;
   permisionDel = true;
   permisionDup = true;
   from = 'dms';
   success: any;
   content: any;
   doc_id: any;
   object_file: any[] = [];

   private page = 1;
   private size = 50;

   percentage: any;
   settype = false;
   position = 'below';
   private progress_dlg: MatDialogRef<UploadFilesComponent>;
   private movedialog: MatDialogRef<MoveDialogComponent>;
   private subscriber: Subscription;
   @ViewChild('toolbar') toolbar: ElementRef;
   limitSize = 10485760;
   supportFolderUpload: boolean;
   limit: any;
   annotationObj: any;
   private itemDocument = {
      id: '',
      item: [],
   };

   event_param:{
      event_page: any,
      event_label: any,
      event_action: any
   }

   private uploadCallback = {
      init: (files) => {
         this.progress.init(files);
      },
      quotaExceed: (i: number, size: number, error: string) => {
         this.progress.quotaExceed(i, size, error);
      },
      limitExceed: (i: number, size: number) => {
         this.progress.limitExceed(i, size, this.limit);
      },
      specialCharacter: (i: number) => {
         this.progress.specialCharacter(i);
      },
      progress: (i: number, progress: number) => {
         this.progress.update(i, progress);
      },
      cancelUpload: (i: number, error: string) => {
         this.progress.cancelUpload(i, error);
      },
      complete: () => {
         const result = this.progress.complete();

         if(result){
            this.googleAnalyticsService.trackEvent('zdox-upload',this.event_param)
         }

         setTimeout(() => {
            this.progress.hide();
            this.docList.saveDoc(this.annotationObj);
            this.loadDocuments();
         }, this.progress.calcDelay());
      }
   };

   constructor(private router: Router, private route: ActivatedRoute, private renderer: Renderer2,
               protected service: IdexService, private upload: UploadService, public uploader: FileUploader,
               private dialog: MatDialog, private filesize: FileSizePipe,
               private translate: TranslateService, private toast: Toast, private app: AppComponent, private googleAnalyticsService:GoogleAnalyticsService) {
   }

   ngOnInit(): void {
      sessionStorage.removeItem('shared');
      localStorage.removeItem('itemSearch');
      this.subscriber = this.route.url.subscribe(url => {
         this.path = decodeURIComponent(url.join('/'));
         this.createBreadcrumb();
         this.showDocument();
         this.getLimitSize();
         this.docList.items = undefined;
         this.limit = this.filesize.transform(this.limitSize);
      });
      const input = document.createElement('input');
      this.supportFolderUpload = ('webkitdirectory' in input
      || 'mozdirectory' in input
      || 'odirectory' in input
      || 'msdirectory' in input
      || 'directory' in input);
   }

   ngOnDestroy(): void {
      this.subscriber.unsubscribe();
   }

   @HostListener('window:scroll')
   scrollFixed() {
      this.toolbar.nativeElement.style.left = (240 - window.scrollX) + 'px';
   }

   private createBreadcrumb(): void {
      this.translate.get('main.files').subscribe(files => {
         if (this.path.length === 0) {
            this.paths = [{name: files}];
            this.docList.paths = this.paths;
            return;
         }
         const paths = [];
         paths.push({name: files, path: '/'});

         let fullPath = '';
         const array = this.path.match(/[^/]+/g);
         for (let i = 0; i < array.length; i++) {
            if (i === array.length - 1) {
               fullPath = null;
            } else {
               if (fullPath.length > 0) {
                  fullPath += '/';
               }
               fullPath += array[i];
            }
            paths.push({name: array[i], path: fullPath});
         }
         this.paths = paths;
         this.docList.paths = this.paths;
      });
   }

   showDocument() {
      this.selectedItems = [];
      if (this.path) {
         this.docList.loadPathInfo(this.path);
      }
      this.page = 1;
      this.service.listDocuments(this.path, this.page, this.size)
         .subscribe(
            data => {
               this.docList.setItems(data.items, data.hasMore, data.metadata);
               document.body.scrollTop = 0;
               if (localStorage.getItem('first_files_open') !== 'true') {
                  this.onStartTutorial();
                  localStorage.setItem('first_files_open', 'true');
               }
            }, error => {
               if (error.status === 404) {
                  this.router.navigate(['/files']);
               }
            });
   }

   onLoadMore() {
      this.service.listDocuments(this.path, this.page + 1, this.size)
         .subscribe(
            data => {
               this.docList.addItems(data.items, data.hasMore);
               if (data.hasMore) {
                  this.page++;
               }
            });
   }

   onClickItem(item: any) {
      let path = location.pathname;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }

      localStorage.setItem('url', Path.combine(path));
      if (item.isFolder) {
         const url = Path.combine('/files', encodeURIComponent(this.path), encodeURIComponent(item.name));
         this.router.navigate([url]);
      } else {
         const getType = item.name.substring(item.name.lastIndexOf(".") + 1, item.name.length);
         if (getType !== 'zdox') {
            this.router.navigate(['/file', item.id]);
         } else {
            localStorage.setItem('filename',item.name);
            localStorage.setItem('callback-url', this.router.url);
            localStorage.setItem('form-type', 'view');
            localStorage.setItem('form-path', this.path);
            this.router.navigate(['/eform/create/docId/' + item.id], {state: {docStatus: item.statusDocument}});
         }
      }
   }

   successUpload1(ans: any): void {
      setTimeout(() => {
         if (ans === this.object_file.length) {
            this.getContentType();
            this.progress_dlg.close();
            this.upload.sum_count = 0;
            this.fileUpload.nativeElement.value = '';
            this.showDocument();
            this.app.uploading = false;
            this.object_file = [];
         }
      }, 1000);
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles && !this.uploader.busy) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         this.renderer.addClass(this.docList.nativeElement, 'drag-over');
      }
   }

   onDrop(e: DragEvent) {
      e.preventDefault();
      e.stopPropagation();
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');

      this.event_param = {
         event_page: "dms",
         event_label: "drop",
         event_action: "upload"
     }

      this.uploader.process(e.dataTransfer, this.limitSize, this.path, null, this.uploadCallback);
   }

   onDragLeave() {
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');
   }

   uploadFolder(files: FileList): void {

      this.event_param = {
         event_page: "dms",
         event_label: "upload-folder",
         event_action: "upload"
     }

      this.uploader.uploadFolder(files, this.limitSize, this.path, null, this.uploadCallback);
   }

   loadDocuments() {
      this.selectedItems = [];
      this.page = 1;
      this.service.listDocuments(this.path, this.page, this.size)
         .subscribe(
            data => {
               this.docList.setItems(data.items, data.hasMore, data.metadata);
            });
   }

   uploadNewVersion(event: any): void {
      this.annotationObj = event.annotationObj;
      this.event_param = {
         event_page: "dms",
         event_label: "upload-new-version",
         event_action: "upload"
     }
      this.uploader.uploadFolder(event.file, this.limitSize, this.path, null, this.uploadCallback, event.item.id, null, event.isMajor);
   }

   uploadSelected(myFiles: any): void {

      this.event_param = {
         event_page: "dms",
         event_label: "upload-file",
         event_action: "upload"
     }

      this.uploader.uploadFolder(myFiles, this.limitSize, this.path, null, this.uploadCallback);
   }

   getContentType(): void {
      this.service.getTypes()
         .subscribe(data => {
            this.content = data;
         });

   }

   onSelectFileNameDropDown(item: any): void {

      const listbody = document.getElementsByTagName('TBODY').length;

      if (listbody !== 0) {
         const row = document.getElementsByTagName('TBODY')[0];
         row.parentNode.removeChild(row);
      }

   }

   onProgressLoad2(percen: any, count: any, file: any): void {
      file.percentage = percen;
      if (!file.close) {
         this.progress_dlg.componentInstance.progressBar_percentage(percen, count);
      }

   }

   onProgressLoadAll(percenall: any) {
      this.progress_dlg.componentInstance.allPercentage(percenall);
   }

   getDocument(id: any): void {
      this.doc_id = id;
      this.service.getDocument(id)
         .subscribe((data: any) => {
            this.doc = data;
            this.settype = !!data.typeName;
         });
   }

   navigate(path: string) {
      this.doc = undefined;
      if (path) {
         const url = Path.combine('/files', encodeURIComponent(path));
         this.router.navigate([url]);
      } else {
         this.router.navigate(['/files']);
      }
   }

   newFolder() {
      this.canDrag = false;
      const dialogRef = this.dialog.open(CreateFolderComponent, {
         disableClose: true,
         data: this,

      });
      dialogRef.componentInstance.toast = this.toast;
      dialogRef.componentInstance.translate = this.translate;
      dialogRef.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   startOnedrive(type: any) {
      this.canDrag = false;
      const onedrive = this.dialog.open(CreateOneDriveComponent, {
         disableClose: true,
         data: this
      });
      onedrive.componentInstance.doctype = type;
      onedrive.componentInstance.path = this.path;
      onedrive.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   startGoogle(type: any) {
      this.canDrag = false;
      const google = this.dialog.open(CreateGoogleDriveComponent, {
         disableClose: true,
         data: {
            filesComponent: this,
            path: this.path,
            type: type
         }
      });
      google.componentInstance.isBusiness = false;
      google.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   onStartTutorial(): void {
      this.translate.get('tutorial').subscribe((msg) => {
         const enjoyhint_instance = new EnjoyHint({});
         const enjoyhint_script_steps = [
            {
               'next #folders-hint': msg.files.navTask,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
               'bottom': -80,
            },
            {
               'next #file-upload-hint': msg.files.upload,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
            },
            {
               'next ul.doclist>li:first': msg.files.filePanel,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
               'bottom': -90,
            },
            {
               'click .itemMenu:first': msg.files.menuList,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
               shape: 'circle'
            },
            {
               'next .mat-menu-panel': msg.files.menuPanel,
               'nextButton': {text: msg.close},
               'showSkip': false
            }
         ];
         enjoyhint_instance.set(enjoyhint_script_steps);
         enjoyhint_instance.run();
      });
   }

   checkSelectItem() {
      this.permisionMove = true;
      this.permisionDel = true;
      this.permisionDup = true;
      if (this.selectedItems) {
         for (const itemSel of this.selectedItems) {
            if (!(itemSel.permissions.write && itemSel.permissions.delete)) {
               this.permisionMove = false;
               this.permisionDup = false;
            }

            if (!itemSel.permissions.delete) {
               this.permisionDel = false;
            }

            if ((itemSel.startFlow && itemSel.statusDocument !== '') || itemSel.isFolder) {
               this.permisionDup = false;
            }

            if (itemSel.startFlow) {
               this.permisionDel = false;
            }

            if (this.isZdoxFile(itemSel)) {
               this.permisionDup = false;
            }
         }
      }
   }

   selectedDownload() {
      const listIds = [];
      let name = 'Archive';
      if (this.selectedItems) {
         if (this.selectedItems.length === 1) {
            name = this.selectedItems[0].name;
         }
         for (const itemSel of this.selectedItems) {
            listIds.push(itemSel.id);
         }
      }

      this.dialog.open(DownloadZipComponent, {
         disableClose: true,
         data: {
            idList: listIds,
            name: name,
            service: this.service
         }
      });
   }

   openSelectedMove() {
      this.movedialog = this.dialog.open(MoveDialogComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems,
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      this.movedialog.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
         }
      });
   }

   duplicate(){
      const listIds = [];
      for(const itemId of this.selectedItems){
         if (this.selectedItems.length > 1) {
            if (!(itemId.startFlow && itemId.statusDocument !== 'Completed')) {
               listIds.push(itemId.id);
            }
         } else {
            listIds.push(itemId.id);
         }
      }
      this.service.duplicateDoc(listIds)
         .subscribe(data => {
            this.translate.get('alert.duplicate_complete').subscribe(s => {
               this.toast.success(s);
               this.docList.showdocument.emit();
               this.selectedItems = [];
            });
         });
   }

   confirmDelete(): void {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems.sort((a: any, b: any) => a.name < b.name ? -1 : 1),
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
         }
      });
   }

   onItemAllSelect(chk: any) {
      for (let i = 0; i < this.docList.items.length; i++) {
         this.docList.items[i].selected = chk.checked;
         const index = this.selectedItems.indexOf(this.docList.items[i]);
         if (this.docList.items[i].selected) {
            if (index === -1) {
               this.selectedItems.push(this.docList.items[i]);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }
      }
   }

   getLimitSize() {
      this.service.get('upload/limitsize')
         .subscribe(value => {
            this.limitSize = value;
            this.limit = this.filesize.transform(this.limitSize);
         });
   }

   share(items: any) {
      this.itemDocument.id = this.docList.dataFolder.parent.nodeRef.split('/')[3];
      this.itemDocument.item = items;
      this.docList.share(this.itemDocument);
   }

   isZdoxFile(item: any): boolean {
      if (item.isFolder) {
         return false;
      }
      let ext = item?.name?.split('.').pop();
      return ext.toLowerCase() === 'zdox';
   }
}
